import * as requestFromServer from "./TeachersCrud";
import { callTypes, teacherSlice } from "./TeachersSlice";

const {actions} = teacherSlice;

export const getTeachers = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getTeachers(queryParams)
    .then(response => {
      dispatch(actions.teachersFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllTeachers = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllTeachers(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getBranches = () => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getBranches()
    .then(response => {
      dispatch(actions.branchesFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getTeacher = id => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  
  if (!id) {
    return requestFromServer
    .getNewTeacher()
    .then(response => {
      dispatch(actions.teacherFetched(response.data));
    })
    .catch(error => {
      
    });
  }
  
  return requestFromServer
    .getTeacher(id)
    .then(response => {
      dispatch(actions.teacherFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const saveTeacher = teacher => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .saveTeacher(teacher)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });    
};

export const renewContracts = ids => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .renewContracts(ids)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const deleteTeachers = ids => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteTeachers(ids)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const deleteContracts = (term, ids) => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteContracts(term, ids)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const cleanTeachersState = () => dispatch => {
  dispatch(actions.teachersStateCleaned());
}